module.exports = __webpack_public_path__ + "static/givemeacolor.351bd813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/givemeacolor.png
// module id = 751
// module chunks = 213720915766396